import { render, staticRenderFns } from "./BackButtonChatList.vue?vue&type=template&id=2a87e01f&scoped=true&"
import script from "./BackButtonChatList.vue?vue&type=script&lang=js&"
export * from "./BackButtonChatList.vue?vue&type=script&lang=js&"
import style0 from "./BackButtonChatList.vue?vue&type=style&index=0&id=2a87e01f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a87e01f",
  null
  
)

export default component.exports